import { Helmet } from 'react-helmet';
import '../Page/DissertationTermsAndConditions.css';
import QuestionsBlogAndChapters from './Terms_And_Conditions/QuestionsBlogAndChapters';
import TermsAndConditionsBanner from './Terms_And_Conditions/TermsAndConditionsBanner';

function DissertationTermsAndConditions() {
  return (
    <>
    <Helmet>
          <title>Dissertation Proposal Writing Help | Professional Writers</title>
          <meta name="description" content="For dissertation writing services we follow some rules and regulations" />
          <meta name="keywords" content="thesis writing services near me, pay someone to write my dissertation, phd thesis online, masters dissertation help, thesis services" />
          <link rel="canonical" href=" https://www.writemydissertationforme.com/termsAndConditions/" />
        </Helmet>
    <TermsAndConditionsBanner />
    <QuestionsBlogAndChapters />
    </>
  )
}

export default DissertationTermsAndConditions;